import { render } from "./LoaderIcon.vue?vue&type=template&id=62762032&scoped=true"
const script = {}

import "./LoaderIcon.vue?vue&type=style&index=0&id=62762032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62762032"]])

export default __exports__